<template>
	<div class="iv2-error__503">
		<div class="iv2-error__503-block">
			<h1 class="iv2-error__503-number">{{ $t('system.error.503') }}</h1>
			<h2 class="iv2-error__503-lead">{{ $t('system.error.lead') }}</h2>
			<p class="iv2-error__503-summary text-pre">{{ $t('system.error.summary') }}</p>
		</div>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.iv2-error__503 {
	background-color: #efefef;
	height: 100vh;
	position: relative;

	.iv2-error__503-block {
		text-align: center;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);

		.iv2-error__503-number {
			font-size: 5.5rem;
		}

		.iv2-error__503-lead {
			font-size: 1.5rem;
			font-weight: 600;
			padding: 2rem 1rem;
			margin: 0;
		}

		.iv2-error__503-summary {
			margin: 0;
		}
	}
}

@media (max-width: 1199px) {
	.iv2-error__503 {
		.iv2-error__503-block {
			.iv2-error__503-lead {
				font-size: 1rem;
			}
		}
	}
}
</style>